import { createNullableProvideInject } from '@collector/shared-ui'

import { ResultWithSliderConfig } from '../configuration'

export const [provideResultWithSliderConfig, injectResultWithSliderConfig] =
  createNullableProvideInject<ResultWithSliderConfig>('resultWithSliderConfig')
